import { createPageApp } from '@/lib/createPageApp'
import WebinarsIndexPage from './WebinarsIndexPage.vue'

createPageApp(WebinarsIndexPage).mount()
